
(function () {

  window.dataLayer = window.dataLayer || [];

  // ==========================================================
  // USERCENTRICS CONSENT AUS DATALAYER ÜBERNEHMEN
  // UND AN SHOPIFY CUSTOM PIXEL WEITERGEBEN
  // ==========================================================

  function saveConsentState(item) {

    if (!item || item.event !== "consent_status") {
      return;
    }

    const consentState = {};

    Object.keys(item).forEach(function (key) {

      // Nur echte Service-Consent-Werte übernehmen
      if (typeof item[key] === "boolean") {
        consentState[key] = item[key];
      }

    });

    // Bestehende Speicherung beibehalten
    const serializedState = JSON.stringify(consentState);

    localStorage.setItem(
      "uc_service_consents",
      serializedState
    );

    console.log(
      "UC service consents gespeichert:",
      consentState
    );

    // ========================================================
    // NEU: CONSENT AN SHOPIFY CUSTOM PIXEL MELDEN
    // ========================================================

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === "function"
    ) {

      window.Shopify.analytics.publish(
        "uc_consent_updated",
        {
          consents: consentState
        }
      );

      console.log(
        "UC: Consent-Update an Shopify veröffentlicht"
      );

    } else {

      console.warn(
        "UC: Shopify Analytics Publish nicht verfügbar"
      );

    }

  }

  // Bereits vorhandene DataLayer-Einträge verarbeiten
  window.dataLayer.forEach(function (item) {
    saveConsentState(item);
  });

  // Zukünftige DataLayer-Pushes überwachen
  const originalPush = window.dataLayer.push;

  window.dataLayer.push = function () {

    for (let i = 0; i < arguments.length; i++) {
      saveConsentState(arguments[i]);
    }

    return originalPush.apply(
      window.dataLayer,
      arguments
    );
  };

})();
